<!-- Agent Card - Displays agent info with hover actions -->
<div 
  class="agent-card"
  [class.is-hovered]="isHovered"
  [class.is-default]="isDefault"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (click)="onCardClick($event)"
  (keydown)="onCardKeyDown($event)"
  role="button"
  tabindex="0"
  [attr.aria-label]="'Agent: ' + agent.name">



  <!-- Card Content -->
  <div class="card-content">
    
    <!-- Agent Icon -->
    <div class="agent-icon-wrapper">
      <img 
        [src]="iconSrc" 
        [alt]="agent.name + ' icon'"
        class="agent-icon"
        (error)="agent.icon = ''">
    </div>

    <!-- Agent Info -->
    <div class="agent-info">
      <h3 class="agent-name">{{ (agent.name || '') | translate }}</h3>
      <p class="agent-description">{{ (agent.description || '') | translate }}</p>
      
      <!-- Category Badge -->
      <app-category-badge
        [category]="categoryName">
      </app-category-badge>
    </div>

  </div>

  <!-- Hover Action Icons (info on hover; star always visible when favorited) -->
  <div class="card-actions" [class.visible]="isHovered">
    
    <!-- Info Icon -->
    <button
      class="action-btn info-btn t-bottom t-no-arrow"
      (click)="onInfoClick($event)"
      type="button"
      aria-label="'VIEW_AGENT_INFO_TOOLTIP' | translate"
      [attr.data-tooltip]="'VIEW_AGENT_INFO_TOOLTIP' | translate">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
        <path d="M8 7V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
        <circle cx="8" cy="5" r="0.75" fill="currentColor"/>
      </svg>
    </button>

    <!-- Favorite Icon (Star) -->
    <button
      class="action-btn favorite-btn t-bottom t-no-arrow"
      [class.is-favorite]="isFavorite"
      (click)="onFavoriteClick($event)"
      type="button"
      [attr.aria-label]="isFavorite ? ('REMOVE_FROM_FAVORITES_TOOLTIP' | translate ): ('ADD_TO_FAVORITES_TOOLTIP' | translate)"
      [attr.data-tooltip]="isFavorite ? ('REMOVE_FROM_FAVORITES_TOOLTIP' | translate) : ('ADD_TO_FAVORITES_TOOLTIP' | translate)">
      <!-- Filled Star (Favorite - Yellow) -->
      <svg *ngIf="isFavorite" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.33333L10.06 5.50666L14.6667 6.18L11.3333 9.42666L12.12 14.0133L8 11.8467L3.88 14.0133L4.66667 9.42666L1.33333 6.18L5.94 5.50666L8 1.33333Z" fill="currentColor"/>
      </svg>
      <!-- Outline Star (Not Favorite) -->
      <svg *ngIf="!isFavorite" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.33333L10.06 5.50666L14.6667 6.18L11.3333 9.42666L12.12 14.0133L8 11.8467L3.88 14.0133L4.66667 9.42666L1.33333 6.18L5.94 5.50666L8 1.33333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Pin Icon (Top Right - only in Default section) -->
    <button 
      *ngIf="isDefault && showPinIcon"
      class="pin-btn t-bottom t-no-arrow"
      (click)="onUnpinClick($event)"
      type="button"
      [attr.aria-label]="'REMOVE_FROM_DEFAULT_TOOLTIP' | translate"
      [attr.data-tooltip]="'REMOVE_FROM_DEFAULT_TOOLTIP' | translate">
      <span class="pin-icon" aria-hidden="true"></span>
    </button>

  </div>

</div>
